import React from 'react'
import './SideNav.css'
import { Link } from 'react-router-dom';
import { useAuth } from '../../auth/AuthContext'

const SideNav = () => {
    const { user, profile, signOut } = useAuth()

    const logout = async () =>{
        await signOut()
        window.location.replace('/')
    }

    return (
        <div className='side-navbar'>
            <ul className='side-navbar-ul'>
                    <li className=''>
                        <a 
                            className='side-log-reg-link' 
                            href="https://nail-labs.square.site/"
                            target='_blank'
                            rel='noopener noreferrer'
                        >
                            More Inspo
                        </a>
                    </li>
                    <li className=''>
                        <a 
                            className='side-log-reg-link' 
                            href='https://maps.app.goo.gl/Y7KAXQVUN6dYDRzV9'
                            target='_blank'
                            rel='noopener noreferrer'
                        >
                            Map Location
                        </a>
                    </li>
                    <li className=''>
                        <a 
                            className='side-log-reg-link' 
                            href='https://g.page/r/CZd1_yQIBuYcEBM/review'
                            target='_blank'
                            rel='noopener noreferrer'
                        >
                            Review Us
                        </a>
                    </li>
                    {profile?.role === 'admin' ? (
                        <li id='control-panel' className='nav-items'>
                            <Link className='links side-cp' to='/admin'>
                                Control Panel
                            </Link>
                        </li>
                    ) : null}
                    {user ? (
                        <li id='user-profile' className='nav-items'>
                            <Link className='links side-up' to='/profile'>
                                User Profile
                            </Link>
                        </li>
                    ) : null}
                </ul>
                {user ? (
                    <div className='side-logout'>
                        <span className='side-user-role'>
                            {profile?.name || 'User'} ({profile?.role || 'client'})
                        </span>
                        <button className='side-btn' onClick={logout}>Logout</button>
                    </div>
                ) : (
                    <div className='side-log-reg'>
                        <Link className='side-log-reg-link' to="/login">
                            Login
                        </Link>
                        <span className='side-separator'></span>
                        <Link className='side-log-reg-link' to="/register">
                            Register
                        </Link>
                    </div>
                )}
                <div className='side-contact'>
                    <a
                        className='side-log-reg-link'
                        href="sms:+13018926640">
                        Text
                    </a>
                    <span className='side-separator'></span>
                    <a
                        className='side-log-reg-link'
                        href="tel:+13016032909">
                        Call
                    </a>
                </div>
        </div>
    )
}

export default SideNav
